module.exports = __webpack_public_path__ + "img/care.830b9a1f.svg";